export const translation = {
  CALCULATE_MIXES_TITLE: "מחשבון משכנתא",
  MORTGAGE_PLANING_IN_CLICK: "לתכנון משכנתא בקליק",
  HEADER_DESCRIPTION:
  "מחשבון המשכנתא מאפשר לכם לקבל הערכה לגבי ההחזר החודשי על הלוואת המשכנתא שאתם מתכננים לקחת. בעזרת המחשבון תוכלו לקבל גם הערכה לגבי גובה ההחזר החודשי הצפוי, וזאת בהתאם לסכום, התקופה והריביות שתבחרו.",  CALCULATE_BY_PRODUCTS_BUTTON_TITLE: "צריכים יותר גמישות? תכננו בעצמכם ",
  CALCULATE_BY_PRODUCTS_BUTTON: "מחשבון משכנתא מורחב",
  CALCULATE_MIXES_BUTTON_TITLE: "רוצים שנציע לכם מסלולי משכנתא?",
  CALCULATE_MIXES_BUTTON: "למחשבון משכנתא",
  CALCULATE_BY_PRODUCTS_TITLE: "איזו משכנתא תרצו?",
  MORTGAGE_CALCULATOR_LINK: "מחשבון משכנתא",
  LOAN_AMOUNT_TITLE: "סכום המשכנתא",
  PERIOD_TITLE: "לכמה שנים",
  YEARS: "שנים",
  SHOW_RESULTS_BUTTON: "כמה תשלמו",
  SHOW_RESULTS_TITLE: "לבקשתך,",
  SHOW_RESULTS_TITLE_2: "בדקנו ומצאנו",
  FOR_LOAN_AMOUNT_OF: "עבור סכום משכנתא של",
  SUM_FOR: "₪ ל-",
  YEARS_SUM_IS: "שנה התשלום הוא",

  TOTAL_AMOUNT: "הסכום שישולם עד סוף התקופה",
  FIRST_PAYMENT: "החזר החודשי הראשון",
  HIGHEST_PAYMENT: "החזר חודשי מקסימילי חזוי",
  MORTGAGE_PERCENTS: "הרכב המשכנתא",
  TOTAL_INTEREST: "ריבית כוללת חזויה",
 
  DISCLAIMER: `הנתונים והחישובים השונים המוצגים במחשבון, לרבות סכומי ההחזר והריבית הכוללת החזויה, הם סימולציה בלבד, ומבוססים על הנתונים שהוזנו על ידכם, 
  ועל תחזיות בנק ישראל לגבי שינויים בעוגנים, בריביות ובאינפלציה, המעודכנות למועד החישוב (תחזיות אלה נועדו להמחיש תשלומים ושיעורי ריבית אפשריים בעתיד, 
    אך אין וודאות כי יתממשו בפועל). הנתונים המוצגים במחשבון עשויים להיות שונים לעומת נתוני המשכנתא שתועמד לכם בפועל, ככל שתועמד, וזאת בין היתר, 
    כפועל יוצא של סכומי ההלוואות מהן מורכבת המשכנתא, תקופת ההלוואות, שיעור הריבית שייקבעו בהלוואות, שינויים שיחולו בריבית בהתאם למנגנון שינוי הריבית (בהלוואות בריבית משתנה), 
    שינויים שיחולו במדד (בהלוואות צמודות מדד), שיטת ההחזר (לוח שפיצר, קרן שווה וכיו"ב), ותשלומים נלווים (כגון ביטוחים, אגרות, עמלות, ריבית ביניים, ריבית פיגורים) וכיו"ב. 
    החישובים במחשבון ו/או תוצאותיו אינם מחייבים את הבנק להעמיד את המשכנתא בפועל או להעמידה, אם תועמד, בתנאים ו/או בריביות שהוזנו/הוצגו. 
    אישור המשכנתא ותנאיה ייקבעו בהתאם לקריטריונים הנהוגים בבנק, כפי שיהיו מעת לעת, 
    ותנאי ההלוואות המחייבים הם אלה שיפורטו בחוזים שייחתמו בין הלווים לבין הבנק. הסכומים המוצגים מעוגלים לשקל הקרוב. אי עמידה בפירעון הלוואת המשכנתא עלול לגרור חיוב בריבית פיגורים והליכי הוצאה לפועל.`,
  MORE_DISCLAIMER_MIX: `הריביות המהוות בסיס לחישובים הן הריביות הממוצעות על "הלוואות לדיור" 
  (למטרת מגורים לפי מסלול ותקופה), בהתאם לפרסומי בנק ישראל לגבי "הלוואות לדיור" שבוצעו בחודש קודם.`,
  MORTGAGE_REQUEST_BUTTON: "להגשת בקשה למשכנתא",
  SHARE: "שיתוף",
  REQUIRED_FIELDS_TITLE: "כל השדות הינם שדות חובה",
  LOAN_AMOUNT: "סכום",
  LOAN_NAME: "שם ההלוואה",
  SCHEDULE_NAME: "שיטת החזר",
  PERIOD: "תקופה",
  INTEREST: "ריבית",
  CALCULATE_BY_PRODUCTS_SUB_TITLE: "עד 5 מסלולים",
  ADD_TRACK: "+ הוספת מסלול",
  CUSTOM_MIX: "תמהיל מותאם אישית",
  TOTAL: "סכום המשכנתא",
  ILS_SIGN: "₪",
  TOOLTIP: {
    PREDICTED_TOTAL_INTEREST: `הריבית הכוללת החזויה (העלות הממשית של האשראי) משקפת את שיעור התשואה הפנימית שהוא השיעור בו הערך 
    הנוכחי של התשלומים הנוכחיים בגין האשראי שווה לערך הנוכחי של סכום האשראי נכון למועד החישוב. שיעור זה משקלל 
    בתוכו מספר פרמטרים , בין היתר התשלומים החודשיים הצפויים ע״ב שינויים צפויים בעוגנים , בריביות ובאינפלציה , 
    בהתאם לתחזיות בנק ישראל. יובהר כי החישוב אינו כולל הוצאות ועמלות הקשורות לביצוע ההלוואה אשר תחויבו בהן 
    בגין העמדת האשראי`,
    MAXIMUM_MONTHLY_REPAYMENT: `סכום ההחזר החודשי הגבוה הצפוי מוצג על מנת לשמש אינדיקטור לשינויים שיכולים לחול
    בגובה ההחזרים החודשיים , על מנת לסייע בבחירת תמהיל ההלוואות המתאים לך. סכום זה מבוסס על התחזיות לשיוניים במדד
    המחירים לצרכן ובשיעורי הריבית במשק שמעודכנות למועד זה. מאחר שסכום זה מבוסס על תחזיות שנגזרות משוק ההון בהתאם
    למציאות הכלכלית בעת גיבושן, ושלא ידוע אם יתממשו , ייתכן שסכום ההחזר החודשי המקסימאלי בפועל יהיה גבוה או 
    נמוך מהסכום המוצג
    `,
    FIRST_MONTHLY_REPAYMENT: `סכום ההחזר החודשי הראשון בגין המשכנתא לחודש מלא, שבמסגרתו ישולמו תשלום חודשי של קרן ההלוואות
    ו/או ריבית ההלוואות. התשלום המוצג אינו כולל שינויים צפויים בריבית או במדד המחירים לצרכן, וכן אינו כולל
    תשלומים נלווים , לרבות אך לא רק , עמלות, ו/או אגרות ו/או פרמיות ביטוח. התשלום החודשי לאורך חיי המשכנתא משתנה בכל 
    המסלולים , למעט במסלול הריבית הקבועה הלא צמודה . השינויים בתשלום החודשי נקבעים על פי השינויים בשיעור ריבית העוגן
     ו/או במדד המחירים לצרכן (בהלוואות צמודות מדד) ולפיכך אין התשלום החודשי הראשון משקף בהכרח את התשלומים החודשיים שתשלמו`,
    AMOUNT_AT_THE_END_OF_THE_PERIOD: `
    סך התשלומים הצפויים בפועל. נתונים אלו מביאים בחשבון את התשלומים החודשיים הצפויים לאורך תקופת המשכנתא 
    על בסיס התחזיות לשינויים במדד המחירים לצרכן ובשיעורי הריבית במשק, שמעודכנות למועד זה . תחזיות אלו נועדו להמחיש 
    תשלומים ושיעורי ריבית אפשריים בעתיד. מכיוון שהתחזיות נגזרות משוק ההון , בהתאם למציאות הכלכלית בעת גיבושן, 
    ולא ברור אם יתממשו , אפשר שהתשלומים ושיעורי הריבית בפועל יהיו שונים`,
    MORTGAGE_PERCENTS: `
     המשכנתא מורכבת במקרים רבים מכמה הלוואות שונות ונפרדות, שמכונות ״מסלולים״ (כל ״המסלולים״ יחד נקראים ״סל״ ).
     ההלוואות (״מסלולים״) נבדלות זו מזו בכמה משתנים, כגון: סוג הריבית, סוג ההצמדה , תכיפות השתנות הריבית , משך ההלוואה ועוד
     `,
  },
  TALK_WITH_US: "דברו איתנו",
  WRITE_TO_US: "כתבו לנו",
  LEUMI_SLOGEN: "לאומי. הכי נוח",
  TO: "ל-",
  SERVICE_ERROR: "אירעה תקלה במערכת",
  TRY_AGAIN_LAYTER: "אנא נסה שנית במועד מאוחר יותר",
  UNDERSTAND: "הבנתי",

  ACCESSIBILITY: {
    LOGO_LEUMI: "לוגו לאומי",
    MORE_INFO_ABOUT_BUTTON: "למידע נוסף על",
    DELETE_TRACK_NUMBER_BUTTON: "כפתור למחיקת מסלול מספר",
    BEYOND_THE_BASKET_RESULT_RIGHT: "מעבר לתוצאה סל אחיד לימין",
    BEYOND_THE_BASKET_RESULT_LEFT: "מעבר לתוצאה סל אחיד לשמאל",
    SCROLL_BUTTON_FOR_BASKET_RESULT: "כפתור גלילה לתוצאה סל אחיד ",
    EDIT: "עריכת מסלול",
    LOADING: "בטעינה, נא להמתין",
  },
};
